import React from 'react';
import Panel from './Panel';
import PessoaFisica from '../../components/Panel/ResumeNew/PessoaFisica';


const PessoaFisicaPage = () => {

    return (
        <Panel>
            <div>
                <PessoaFisica />
            </div>
        </Panel>

    );
};

export default PessoaFisicaPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/PessoaFisicaPage.js
 **/